// extracted by mini-css-extract-plugin
export var calendarView = "_mw-0";